export default __webpack_public_path__ + "static/ma-dph-b17d83fcb7b947f66ddc8a09e28e6222.png";